import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "25",
            height: "25",
            viewBox: "0 0 25 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M11 21.8147C11 21.8147 9.5 21.8147 9.5 20.3147C9.5 18.8147 11 14.3147 17 14.3147C23 14.3147 24.5 18.8147 24.5 20.3147C24.5 21.8147 23 21.8147 23 21.8147H11ZM17 12.8147C18.1935 12.8147 19.3381 12.3406 20.182 11.4967C21.0259 10.6528 21.5 9.50817 21.5 8.3147C21.5 7.12122 21.0259 5.97663 20.182 5.13272C19.3381 4.2888 18.1935 3.8147 17 3.8147C15.8065 3.8147 14.6619 4.2888 13.818 5.13272C12.9741 5.97663 12.5 7.12122 12.5 8.3147C12.5 9.50817 12.9741 10.6528 13.818 11.4967C14.6619 12.3406 15.8065 12.8147 17 12.8147V12.8147Z",
                    fill: "#A176F3"
                }),
                /*#__PURE__*/ _jsx("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M8.324 21.8147C8.10163 21.3464 7.99073 20.833 8 20.3147C8 18.2822 9.02 16.1897 10.904 14.7347C9.96364 14.445 8.98392 14.3033 8 14.3147C2 14.3147 0.5 18.8147 0.5 20.3147C0.5 21.8147 2 21.8147 2 21.8147H8.324Z",
                    fill: "#A176F3"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M7.25 12.8147C8.24456 12.8147 9.19839 12.4196 9.90165 11.7163C10.6049 11.0131 11 10.0593 11 9.0647C11 8.07014 10.6049 7.11631 9.90165 6.41305C9.19839 5.70979 8.24456 5.3147 7.25 5.3147C6.25544 5.3147 5.30161 5.70979 4.59835 6.41305C3.89509 7.11631 3.5 8.07014 3.5 9.0647C3.5 10.0593 3.89509 11.0131 4.59835 11.7163C5.30161 12.4196 6.25544 12.8147 7.25 12.8147V12.8147Z",
                    fill: "#A176F3"
                })
            ]
        })
    }));
};
export default Icon;
